import Slider from '../slider';

export default (element, data) => {
  const { visibleTiles } = data;
  const visibleTilesConverted = visibleTiles === 'three' ? 3 : 4;
  let slider = null;

  const initSlider = () => {
    if (element.querySelector('[data-category-slider]')) {
      const prevEl = element.querySelector('[data-category-slider-prev]');
      const nextEl = element.querySelector('[data-category-slider-next]');
      const paginationEl = element.querySelector('[data-category-slider-pagination]'); 

      slider = new Slider({
        el: element.querySelector('[data-category-slider]'),
        options: {
          slidesPerView: 2,
          spaceBetween: 10,
          loop: true,
          breakpoints: {
            1024: {
              slidesPerView: visibleTilesConverted
            }
          },
          navigation: {
            nextEl,
            prevEl,
          },
          pagination: { 
            el: paginationEl,
            clickable: true,
          },
        },
      });
    }
    return slider;
  };

  initSlider();
};
